// Lets elements with role="button" respond to Enter/Space the same way a real <button> would.
export function onActivateKeydown(e: KeyboardEvent, action: () => void) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    action();
  }
}
